import Store from 'lightningjs-redux';
import { createItemAction } from '../../cta/cta.actions';
import { ProfilesGate } from '../../profilesGate/profilesGate.component';
import { checkProfileAutoSelect } from '../../../logic/lock/lock.actions';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL } from '../../popupContainer/popupContainer.constants';

export class ProfilesGatePopup extends ProfilesGate {
  static _template() {
    return {
      ...super._template(),
      passSignals: {
        [HIDE_POPUP_SIGNAL]: true,
        [EXIT_APP_SIGNAL]: true,
      },
    };
  }

  set payload(value) {
    Store.dispatch(checkProfileAutoSelect(value));
    this.data = value;
  }

  _handleSelected(item) {
    this.signal(HIDE_POPUP_SIGNAL);

    return Store.dispatch(createItemAction({ item }));
  }
}
